import React from 'react';
import PropTypes from 'prop-types';
import { openTab } from '../../../src/utils/openTab';
import FSFlatButton from '../../../src/components/lib/FSFlatButton';

const CiriumAircraftEmissionsLink = 'https://www.cirium.com/thoughtcloud/new-airline-co2-emissions-monitor-reveals-40percent-less-fuel-burnt-flights-flown-globally-2021/?cmpid=ilc%7Cairlines-airports%7CCI091-2021-11-iata-slots&sfid=77014G000001e6n2QAA';

const wordiness = 'Cirium launches a Global Aircraft Emissions Monitor to accurately measure CO2 emissions and fuel consumption of flights flown globally, by aircraft type, flight, and tail number.';

const AircraftEmissionsMonitor = (props) => {
  const {
    reportButtonPress,
  } = props;

  return (
    <div className='homepage-aem-section'>
      <div className='homepage-aem-content'>
        <h4 className='homepage-aem-text'>{wordiness}</h4>
        <div className='homepage-cirium-button-container'>
          <FSFlatButton
            href={CiriumAircraftEmissionsLink}
            backgroundColor='#00856C'
            label='READ ANNOUNCEMENT'
            onClick={(e) => {
              e.preventDefault();
              reportButtonPress('AircraftEmissionsMonitor');
              openTab(CiriumAircraftEmissionsLink);
            }}
          />
        </div>
      </div>
      <div className='homepage-aem-image' />
    </div>
  );
};

AircraftEmissionsMonitor.propTypes = {
  reportButtonPress: PropTypes.func,
};

export default AircraftEmissionsMonitor;



// WEBPACK FOOTER //
// ./modules/Homepage/components/AircraftEmissionsMonitor.js